import { Image } from '../../../../components/Image/Image';
import styles from './PaymentMethod.module.scss';
import { PaymentMethodCard } from './PaymentMethodCard/PaymentMethodCard';
import { PaymentMethodApplePay } from './PaymentMethodCard/PaymentMethodApplePay';
import { PaymentMethodPayPal } from './PaymentMethodCard/PaymentMethodPayPal';
import { useRef, useState } from 'react';
import { getCurrencySymbol } from '../../../../services/getCurrencySymbol';
import { formatCentsToDollars } from '../../../../services/formatCentsToDollars';
import { getDynamicFooterInfo } from './getDynamicFooterInfo';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentMethodGooglePay } from './PaymentMethodCard/PaymentMethodGooglePay';
import { ampCheckoutView } from '../../../../utils/AmplitudeEvents';
import { trackGoogleAdsCheckoutStart } from '../../../../utils/GoogleAdsFunnelEvents';
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);
export const PaymentMethod =({content, data,currency})=>{
  const [activeIndex, setActiveIndex] = useState(null);
  const { title, methods, policyPages, reviewIcon, footerRecieve,footerRenew } = content;
  const { userData } = useUserData();
  const email = userData?.email;
  const initializedRef = useRef(false);
  const availableMethodsRef = useRef({})
  if(!content || !data ) return null;
  const onAvailable = (index) => {
    availableMethodsRef.current[index] = true;
    if (!initializedRef.current) {
      setActiveIndex(index);
      initializedRef.current = true;
    }
  };
  const handleClick = (index, method) => {
    setActiveIndex(index);
    trackGoogleAdsCheckoutStart();
    if (method.type !== 'applepay') {
      ampCheckoutView(data.title, data.salePrice / 100, currency);
    }
  };
  const currencySymbol = getCurrencySymbol(currency)
  const {salePrice,fullPrice,fullPriceAfterCost,period} = data;
  const currentPrice = formatCentsToDollars(salePrice)
  const fullPriceAfter = formatCentsToDollars(fullPriceAfterCost || fullPrice)
  const dinamicSubtitle = `For ${currencySymbol}${currentPrice.integer}.${currentPrice.fraction} for ${period} of access, experience how Hapday can improve your life.`;
  const dinamicFooterInfo = getDynamicFooterInfo(data?.periodDays);
  const options = {
    mode: 'payment',
    amount: parseInt(data.salePrice, 10),
    currency: currency,
    setup_future_usage: 'off_session',
    loader:'always'
  };
  return (
    <div className={styles.wrapper} id="payment-method">
      {title && <h2 className={styles.title}>{title}</h2>}
      {dinamicSubtitle && <p className={styles.subtitle}>{dinamicSubtitle}</p>}
      {methods && (
        <Elements stripe={stripePromise} options={options}>
          <div className={styles.methods}>
            {methods.map((method, index) => {
              const isActive = activeIndex === index;
              // Передаём пропсы для клика и "callback доступности"
              const commonProps = {
                data,
                method,
                currency,
                email,
                status: isActive ? 'open' : undefined,
                onClick: () => handleClick(index, method),
                onAvailable: () => onAvailable(index)
              };
              switch (method.type) {
                case 'applepay':
                  return <PaymentMethodApplePay key={index} {...commonProps} />;
                case 'googlepay':
                  return <PaymentMethodGooglePay key={index} {...commonProps} />;
                case 'paypal':
                  return <PaymentMethodPayPal key={index} {...commonProps} />;
                case 'card':
                  return <PaymentMethodCard key={index} {...commonProps} />;
                default:
                  return null;
              }
            })}
          </div>
        </Elements>
      )}
      {/* devices icons */}
      <div className={styles.devices}>
        {content.devices.map((device, index)=>{
          return <Image key={index} src={device} className={styles.device}/>
        })}
      </div>
      {reviewIcon && <Image src={reviewIcon} className={styles.reviewIcon}/>}
      {dinamicFooterInfo && <p className={styles.footerInfo} dangerouslySetInnerHTML={{ __html:dinamicFooterInfo  }}/>}
      {policyPages && <div className={styles.policyPages} dangerouslySetInnerHTML={{ __html:policyPages  }}/>}
      <ul className={styles.footerText}>
        {footerRecieve && <li  className={styles.text}>{footerRecieve}</li>}
        {footerRenew && <li  className={styles.text}>{footerRenew} {currencySymbol}{fullPriceAfter.integer}.{fullPriceAfter.fraction}</li>}
      </ul>
    </div>
  )
}
